import { useEffect, useState } from 'react';

const serviceGroups = [
  {
    label: 'Connectivity & Hosting',
    image: 'https://readdy.ai/api/search-image?query=modern%20data%20center%20corridor%20with%20illuminated%20server%20racks%20and%20structured%20cabling%2C%20symmetrical%20perspective%2C%20cinematic%20low-key%20lighting%20with%20warm%20amber%20accent%20lights%20against%20deep%20charcoal%2C%20premium%20technology%20editorial%20photography&width=800&height=480&seq=teknyq-svc-connectivity&orientation=landscape',
    items: [
      { icon: 'ri-wifi-line', name: 'Internet Provider Services' },
      { icon: 'ri-server-line', name: 'Data Center Infrastructure' },
      { icon: 'ri-mail-settings-line', name: 'Private Web & Email Hosting' },
      { icon: 'ri-cpu-line', name: 'AI · Web · Email · Gaming Servers' },
      { icon: 'ri-database-2-line', name: 'VPS' },
    ],
  },
  {
    label: 'Networks & Communications',
    image: 'https://readdy.ai/api/search-image?query=close%20up%20of%20an%20enterprise%20network%20switch%20with%20glowing%20status%20lights%20and%20ethernet%20cables%20in%20a%20dark%20server%20rack%2C%20warm%20amber%20highlights%2C%20shallow%20depth%20of%20field%2C%20premium%20technology%20editorial%20photography&width=800&height=480&seq=teknyq-svc-networks&orientation=landscape',
    items: [
      { icon: 'ri-router-line', name: 'Computer Networks & IoT' },
      { icon: 'ri-phone-line', name: 'VOIP Phone Systems' },
      { icon: 'ri-shield-check-line', name: 'Security Assessments' },
    ],
  },
  {
    label: 'Security & Access Control',
    image: 'https://readdy.ai/api/search-image?query=modern%20security%20camera%20and%20access%20control%20panel%20in%20a%20dark%20commercial%20building%20lobby%2C%20intercom%20entry%20system%2C%20moody%20cinematic%20lighting%20with%20warm%20amber%20accents%2C%20shallow%20depth%20of%20field%2C%20premium%20technology%20editorial%20photography&width=800&height=480&seq=teknyq-svc-security&orientation=landscape',
    items: [
      { icon: 'ri-vidicon-line', name: 'Analog & IP Security Cameras' },
      { icon: 'ri-key-2-line', name: 'Intercom & Telephone Entry Systems' },
      { icon: 'ri-door-lock-line', name: 'Electrified Gate Operators' },
      { icon: 'ri-door-open-line', name: 'Automated Pedestrian Door Operators' },
      { icon: 'ri-alarm-warning-line', name: 'Intrusion Systems' },
      { icon: 'ri-radar-line', name: 'Perimeter Detection Systems' },
    ],
  },
];

const navItems = ['Services', 'IoT Engineering', 'About', 'Contact'];

export default function Home() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const closeMenu = () => setMenuOpen(false);

  return (
    <div className="min-h-screen bg-[#0e0e10] text-neutral-100 font-sans" style={{ fontFamily: "'Inter', system-ui, sans-serif" }}>
      {/* NAV */}
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled ? 'bg-[#0e0e10]/85 backdrop-blur-md border-b border-white/5' : 'bg-transparent'
        }`}
      >
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
          <a href="#top" className="flex items-center gap-2 cursor-pointer">
            <div className="w-8 h-8 flex items-center justify-center rounded-md bg-[#c9a24a] text-black font-bold" style={{ fontFamily: "'Playfair Display', serif" }}>
              T
            </div>
            <div className="flex flex-col leading-tight">
              <span className="font-semibold tracking-tight text-[15px]">TEKNYQ, LTD</span>
              <a
                href="mailto:support@teknyq.com"
                className="text-xs text-neutral-400 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
              >
                support@teknyq.com
              </a>
            </div>
          </a>
          <div className="hidden md:flex items-center gap-8">
            {navItems.map((item) => (
              <a
                key={item}
                href={`#${item.toLowerCase().replace(/\s+/g, '-')}`}
                className="text-sm text-neutral-300 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
              >
                {item}
              </a>
            ))}
          </div>
          <div className="hidden md:flex items-center gap-6">
            <a
              href="mailto:support@teknyq.com"
              className="inline-flex items-center gap-2 text-sm text-neutral-300 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-mail-line w-4 h-4 flex items-center justify-center"></i>
              support@teknyq.com
            </a>
            <a
              href="tel:+18444835697"
              className="inline-flex items-center gap-2 rounded-full bg-[#c9a24a] hover:bg-[#d4b25e] text-black text-sm font-medium px-5 py-2 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-line w-4 h-4 flex items-center justify-center"></i>
              844-4-TEKNYQ
            </a>
          </div>
          <button
            onClick={() => setMenuOpen((v) => !v)}
            className="md:hidden w-9 h-9 flex items-center justify-center text-neutral-200 cursor-pointer"
            aria-label="Toggle menu"
          >
            <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl`}></i>
          </button>
        </div>

        {/* Mobile dropdown menu */}
        {menuOpen && (
          <div className="md:hidden bg-[#111114] border-t border-white/5 px-6 py-4">
            <div className="flex flex-col gap-1">
              {navItems.map((item) => (
                <a
                  key={item}
                  href={`#${item.toLowerCase().replace(/\s+/g, '-')}`}
                  onClick={closeMenu}
                  className="flex items-center justify-between rounded-lg px-3 py-3 text-sm text-neutral-200 hover:bg-white/5 transition-colors cursor-pointer"
                >
                  {item}
                  <i className="ri-arrow-right-s-line text-neutral-500"></i>
                </a>
              ))}
            </div>

            <div className="mt-4 border-t border-white/5 pt-4 flex flex-col gap-3">
              <a
                href="mailto:support@teknyq.com"
                onClick={closeMenu}
                className="inline-flex items-center gap-2 text-sm text-neutral-300 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-mail-line w-4 h-4 flex items-center justify-center"></i>
                support@teknyq.com
              </a>
              <a
                href="tel:+18444835697"
                onClick={closeMenu}
                className="inline-flex items-center justify-center gap-2 rounded-full bg-[#c9a24a] hover:bg-[#d4b25e] text-black text-sm font-medium px-5 py-3 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-line w-4 h-4 flex items-center justify-center"></i>
                Toll Free 844-4-TEKNYQ
              </a>
            </div>
          </div>
        )}
      </nav>

      {/* HERO */}
      <section id="top" className="relative pt-40 pb-24 md:pt-48 md:pb-32 overflow-hidden">
        {/* Video background */}
        <video
          className="absolute inset-0 w-full h-full object-cover"
          autoPlay
          muted
          loop
          playsInline
          onLoadedMetadata={(e) => {
            e.currentTarget.playbackRate = 0.5;
          }}
          onPlay={(e) => {
            e.currentTarget.playbackRate = 0.5;
          }}
          poster="https://public.readdy.ai/ai/img_res/edited_1309a1c70e63e176f8929b096983a615_579394ba.jpg"
        >
          <source src="https://assets.mixkit.co/videos/12262/12262-720.mp4" type="video/mp4" />
        </video>

        {/* Overlays for legibility */}
        <div className="absolute inset-0 bg-[#0e0e10]/75"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-[#0e0e10]/70 via-[#0e0e10]/55 to-[#0e0e10]"></div>
        <div
          className="absolute inset-0 opacity-[0.35] pointer-events-none"
          style={{
            backgroundImage:
              "radial-gradient(circle at 18% 20%, rgba(201,162,74,0.28), transparent 45%), radial-gradient(circle at 82% 60%, rgba(120,90,40,0.2), transparent 50%)",
          }}
        ></div>
        <div
          className="absolute inset-0 opacity-[0.08] pointer-events-none"
          style={{
            backgroundImage:
              'linear-gradient(rgba(255,255,255,0.15) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.15) 1px, transparent 1px)',
            backgroundSize: '60px 60px',
          }}
        ></div>

        <div className="relative max-w-[1400px] mx-auto px-6 md:px-10">
          <div className="flex items-center gap-3 mb-8">
            <span className="w-2 h-2 rounded-full bg-[#c9a24a] animate-pulse"></span>
            <span className="text-xs uppercase tracking-[0.2em] text-neutral-400">Consultation · Installation · Servicing</span>
          </div>

          <h1 className="max-w-5xl text-4xl md:text-6xl lg:text-7xl font-medium leading-[1.05] tracking-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
            Secure. Connected. <span className="italic text-[#c9a24a]">Engineered</span> for your business.
          </h1>

          <p className="mt-8 max-w-2xl text-lg text-neutral-400 leading-relaxed">
            From internet and hosting to security cameras, access control and IoT — we design, install and service custom technology systems you can actually depend on.
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-4">
            <a href="#services" className="inline-flex items-center gap-2 rounded-full bg-[#c9a24a] hover:bg-[#d4b25e] text-black text-sm font-medium px-6 py-3 transition-colors cursor-pointer whitespace-nowrap">
              See what we offer
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
            </a>
            <a href="tel:+18444835697" className="inline-flex items-center gap-2 rounded-full border border-white/15 hover:border-white/40 text-sm font-medium px-6 py-3 transition-colors cursor-pointer whitespace-nowrap">
              <i className="ri-phone-line w-4 h-4 flex items-center justify-center"></i>
              Call 844-4-TEKNYQ
            </a>
          </div>

          <div className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-8 max-w-3xl">
            {[
              { k: '30', v: 'Years of experience' },
              { k: '24/7', v: 'Installation & servicing' },
              { k: '100%', v: 'Custom engineered' },
              { k: '1', v: 'Call for everything' },
            ].map((s) => (
              <div key={s.v}>
                <div className="text-3xl md:text-4xl font-medium text-[#c9a24a]" style={{ fontFamily: "'Playfair Display', serif" }}>{s.k}</div>
                <div className="mt-1 text-xs md:text-sm text-neutral-400">{s.v}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SERVICES */}
      <section id="services" className="py-24 md:py-32 border-t border-white/5 bg-[#111114]">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10">
          <div className="max-w-3xl mb-16">
            <div className="text-xs uppercase tracking-[0.2em] text-[#c9a24a] mb-4">Consultation, Installation & Servicing</div>
            <h2 className="text-3xl md:text-5xl font-medium tracking-tight leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
              Ask us about any of these systems.
            </h2>
            <p className="mt-4 text-neutral-400 max-w-2xl">
              One team for your connectivity, your network, and your physical security — designed together, installed right, and serviced for the long run.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            {serviceGroups.map((group) => (
              <div key={group.label} className="rounded-xl border border-white/5 bg-[#16161a] p-5 md:p-6">
                <div className="relative w-full h-40 rounded-lg overflow-hidden mb-5">
                  <img
                    src={group.image}
                    alt={`${group.label} systems installed and serviced by TEKNYQ, LTD`}
                    title={`${group.label} - TEKNYQ, LTD`}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#16161a] via-[#16161a]/25 to-transparent"></div>
                  <h3 className="absolute bottom-3 left-4 right-4 text-xs uppercase tracking-[0.15em] text-white font-medium">{group.label}</h3>
                </div>
                <ul className="space-y-3">
                  {group.items.map((item) => (
                    <li key={item.name} className="group flex items-center gap-3 rounded-lg px-3 py-2.5 hover:bg-white/5 transition-colors cursor-pointer">
                      <div className="w-9 h-9 flex items-center justify-center rounded-md bg-white/5 text-neutral-400 group-hover:bg-[#c9a24a]/10 group-hover:text-[#c9a24a] transition-colors">
                        <i className={`${item.icon} text-lg`}></i>
                      </div>
                      <span className="text-sm text-neutral-200">{item.name}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* IOT ENGINEERING */}
      <section id="iot-engineering" className="py-24 md:py-32">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-6">
            <div className="text-xs uppercase tracking-[0.2em] text-[#c9a24a] mb-4">Professional IoT Services</div>
            <h2 className="text-3xl md:text-5xl font-medium tracking-tight leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
              Full engineering & design, built around <span className="italic text-[#c9a24a]">you.</span>
            </h2>
          </div>
          <div className="lg:col-span-6">
            <p className="text-lg text-neutral-300 leading-relaxed mb-6">
              We offer full engineering and design services to create custom business products and systems. Our highly experienced technology experts are here to help you design and build the solution you need — for your business.
            </p>
            <div className="flex flex-wrap gap-3">
              {['Engineering', 'Design', 'Integration', 'Installation', 'Ongoing Support'].map((tag) => (
                <span key={tag} className="rounded-full border border-white/10 px-4 py-1.5 text-sm text-neutral-300 whitespace-nowrap">
                  {tag}
                </span>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ABOUT */}
      <section id="about" className="py-24 md:py-32 bg-[#111114] border-t border-white/5">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-5">
            <div className="text-xs uppercase tracking-[0.2em] text-[#c9a24a] mb-4">About Us</div>
            <h2 className="text-3xl md:text-5xl font-medium tracking-tight leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
              Nearly 30 years of getting it right.
            </h2>
          </div>
          <div className="lg:col-span-7">
            <p className="text-lg text-neutral-300 leading-relaxed mb-6">
              With nearly 30 years of experience, we are dedicated to our clients, and they benefit from our strong mission and clear vision.
            </p>
            <p className="text-neutral-400 leading-relaxed">
              If you're looking to network or secure your business, call us today for a comprehensive solution package based on your budget and requirements.
            </p>
            <a
              href="tel:+18444835697"
              className="mt-8 inline-flex items-center gap-2 rounded-full bg-[#c9a24a] hover:bg-[#d4b25e] text-black text-sm font-medium px-6 py-3 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-line w-4 h-4 flex items-center justify-center"></i>
              Get your solution package
            </a>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section id="contact" className="py-24 md:py-32">
        <div className="max-w-[1100px] mx-auto px-6 md:px-10 text-center">
          <div className="text-xs uppercase tracking-[0.2em] text-[#c9a24a] mb-6">Start a conversation</div>
          <h2 className="text-3xl md:text-5xl font-medium tracking-tight leading-tight max-w-3xl mx-auto" style={{ fontFamily: "'Playfair Display', serif" }}>
            Tell us what you're building. We'll design the solution.
          </h2>
          <p className="mt-6 text-neutral-400 max-w-xl mx-auto">
            No obligation — just an honest look at your network, your security, and what fits your budget.
          </p>
          <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
            <a href="tel:+18444835697" className="inline-flex items-center gap-2 rounded-full bg-[#c9a24a] hover:bg-[#d4b25e] text-black text-sm font-medium px-6 py-3 transition-colors cursor-pointer whitespace-nowrap">
              <i className="ri-phone-line w-4 h-4 flex items-center justify-center"></i>
              Toll Free 844-4-TEKNYQ
            </a>
            <a href="mailto:support@teknyq.com" className="inline-flex items-center gap-2 rounded-full border border-white/15 hover:border-white/40 text-sm font-medium px-6 py-3 transition-colors cursor-pointer whitespace-nowrap">
              <i className="ri-mail-line w-4 h-4 flex items-center justify-center"></i>
              support@teknyq.com
            </a>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="border-t border-white/5 bg-[#111114]">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-10 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <div className="w-7 h-7 flex items-center justify-center rounded-md bg-[#c9a24a] text-black font-bold text-sm" style={{ fontFamily: "'Playfair Display', serif" }}>T</div>
            <span className="text-sm text-neutral-400">© 2026 TEKNYQ, LTD. Built to depend on.</span>
          </div>
          <div className="flex items-center gap-6 text-sm text-neutral-500">
            <a href="tel:+18444835697" className="hover:text-neutral-200 cursor-pointer">844-4-TEKNYQ</a>
            <a href="mailto:support@teknyq.com" className="hover:text-neutral-200 cursor-pointer">support@teknyq.com</a>
          </div>
        </div>
      </footer>
    </div>
  );
}